<template>
  <div>
    <el-dialog title="Withdraw Rewards" :visible.sync="open" class="my_dia">
      <div class="con">
        <p><i class="el-icon-warning"></i> Are you sure you want to withdraw all rewards?</p>
        <p>Rewards:
          <big-number :number="row.rewards" class="num"/>
          UNIT
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="open = false">Cancel</el-button>
        <el-button type="primary" @click="handleWithdraw">Withdraw</el-button>
      </span>

    </el-dialog>


    <handle ref="handleCom" @success="handleSuccess"></handle>
  </div>

</template>

<script>
import handle from "@/views/stake/handle/index"
import {toBigNum, toBigItem, toSmallNumStr} from "@/utils/bigNumberTran.js";

export default {
  components: {
    handle
  },
  data() {
    return {
      open: false,
      row: {},
    }
  },
  methods: {
    show(row) {
      console.log(row)
      this.row = row
      this.open = true
    },
    handleWithdraw() {
      this.$refs.handleCom.handle({
        account: this.$store.getters.metaMaskObj.account,
        validatorAddress: this.row.delegation.validator_address,
        type: 'withdraw',
        amount: undefined
      })
    },
    handleSuccess() {
      this.$message.success('Reward withdrawal successfully!')
      this.open = false
      setTimeout(() => {
        this.$emit('success')
      }, 5000);
    },


  }

}
</script>

<style lang="scss" scoped>

.el-button--primary {
  background: #2675F1;
  border-color: #2675F1;
}

.num {
  font-size: 0.28rem;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #1F1F1F;
}


.con {
  p:first-child {
    font-size: 0.24rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #1F1F1F;
    line-height: 0.28rem;

    .el-icon-warning {
      color: #FFA200;
    }
  }

  p:last-child {
    font-size: 0.2rem;
    font-family: Roboto-Regular, Roboto;
    font-weight: 500;
    color: #1F1F1F;
    line-height: 0.24rem;
    padding-left: 0.3rem;

  }
}
</style>
